/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { Row, Col, Input, Select, message, Modal, DatePicker, Form } from 'antd'
import { Link } from 'react-router-dom'
import _ from 'lodash'
import moment from 'moment'
import { observer, inject } from 'mobx-react'
import { compose } from 'recompose'
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'

import ContituentSelect from '../../../components/Custom/ConstituentSelect'
import ConstituentDetails from '../details'

class Index extends Component {
	constructor(props) {
		super(props)

		this.state = {
			isSaving: false,
			selectedConstituent: null,
			didSelectConstituent: false,
			selectedOfficer: null,
			didSelectOfficer: false
		}
        
		this.handleSubmit = this.handleSubmit.bind(this)
	}
    
	handleSubmit(e) {
		e.preventDefault()
		const { selectedConstituent } = this.state
		const { form, AuthStore, saveCertificate, onClose } = this.props
		const { barangay_uid } = AuthStore
		const { resetFields } = form
		
		form.validateFields((err, values) => {
			if (err) {
				return false
			}

			const request_date = moment(values.request_date).format('YYYY-MM-DD HH:mm:ss')
			let params = Object.assign({}, values, {
				barangay_uid,
				name: (!selectedConstituent.didSelectConstituent) ? selectedConstituent.name : `${selectedConstituent.first_name} ${selectedConstituent.middle_name || ''} ${selectedConstituent.last_name}`,
				constituent_uid: selectedConstituent.uid,
				request_date
			})
			// console.log('params', params)

			message.loading({ key: 'set_certificate', content: 'Generating Certificate, please wait..' })
			this.setState({ isSaving: true }, () => {
				saveCertificate(params).then((response) => {
					const { file_url } = response.data.setCertificateBurial
					window.open(`${process.env.REACT_APP_BACKEND_API}${file_url}`, '_blank')
					this.setState({ isSaving: false })
					message.success({ key: 'set_certificate', content: 'Certificate successfully generated.' })

					//create audit trail
					const auditParams = {
						module_name: 'Certificate',
						action: 'Create',
						message: 'Generate Certificate of Residency'
					}
					AuthStore.saveAuditTrail(auditParams)

					onClose()
				}).catch(err => {
					this.setState({ isSaving: false })
					console.log('error generating certificate')
					message.error({ key: 'set_certificate', content: err.message.replace('GraphQL error:', '') })
					resetFields()
				})
			})
		})
	}

	render() {
		const { visible, onClose, form, AuthStore } = this.props
		const { getFieldDecorator } = form
		const { barangay_uid, or_required } = AuthStore
		const { selectedConstituent, isSaving } = this.state
		
		return (
			<Modal
				title="Certificate of Burial"
				// placement="right"
				// closable={!isSaving}
				// onClose={onClose}
				visible={visible}
				width={'70%'}
				// bodyStyle={{ maxHeight: '90%', overflow: 'scroll' }}
				okText='Generate'
				maskClosable={!isSaving}
				onCancel={onClose}
				onOk={this.handleSubmit}
				confirmLoading={isSaving}
			>
				<Form onSubmit={this.handleSubmit}>
					{
						selectedConstituent &&
						<ConstituentDetails selectedConstituent={selectedConstituent} table_name='certificate_burial' />
					}
					<Row gutter={16}>
						<Col md={16} sm={24}>
							<Form.Item label='Constituent'>
								{ getFieldDecorator('constituent_uid', {
									rules: [{
										required: true,
										message: 'This field is required.'
									}]
								})
								(
									<ContituentSelect 
										barangay_uid={barangay_uid}
										placeholder='Select Constituent Name'
										onSelectedItem={(item) => {
											if (item) {
												this.setState({ selectedConstituent: Object.assign({}, item, { didSelectConstituent: true }) })
											} else {
												this.setState({ selectedConstituent: null })
											}
										}}
									/>
								)}
							</Form.Item>
						</Col>
						<Col md={8} sm={24}>
							<Form.Item label='Request Date'>
								{ getFieldDecorator('request_date', {
									initialValue: moment(new Date()),
									rules: [{
										required: true,
										message: 'This field is required.'
									}]
								})
								(
									<DatePicker format='LL' style={{ width: '100%' }}/>
								)}
							</Form.Item>
						</Col>
						{/* {
							or_required &&
							<Col md={12} sm={24}>
								<Form.Item label='OR Number'>
									{ getFieldDecorator('or_number', {
										rules: [{
											required: true,
											message: 'This field is required.'
										}, {
											validator: (rule, value, callback) => {
												if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
													callback('only white space detected.')
												}
												callback()
											}
										}]
									})
									(
										<Input placeholder='Enter OR Number' />
									)}
								</Form.Item>
							</Col>
						}
						{
							or_required &&
							<Col md={12} sm={24}>
								<Form.Item label='Amount'>
									{ getFieldDecorator('amount', {
										rules: [{
											required: true,
											message: 'This field is required.'
										}, {
											validator: (rule, value, callback) => {
												if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
													callback('only white space detected.')
												}
												callback()
											}
										}]
									})
									(
										<Input type='number' min={0} placeholder='Enter Amount' />
									)}
								</Form.Item>
							</Col>
						} */}
						<Col md={12} sm={24}>
							<Form.Item label='Name of Deceased'>
								{ getFieldDecorator('deceased_name', {
									rules: [{
										required: true,
										message: 'This field is required.'
									}, {
										validator: (rule, value, callback) => {
											if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
												callback('only white space detected.')
											}
											callback()
										}
									}]
								})
								(
									<Input placeholder='Enter Name of deceased' />
								)}
							</Form.Item>
						</Col>
						<Col md={12} sm={24}>
							<Form.Item label='Relation to deceased'>
								{ getFieldDecorator('deceased_relation', {
									rules: [{
										required: true,
										message: 'This field is required.'
									}, {
										validator: (rule, value, callback) => {
											if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
												callback('only white space detected.')
											}
											callback()
										}
									}]
								})
								(
									<Input placeholder='Enter relation to deceased' />
								)}
							</Form.Item>
						</Col>
					</Row>
					{/* <Row>
						<Form.Item label='Purpose of Certificate'>
							{ getFieldDecorator('purpose', {
								rules: [{
									required: true,
									message: 'This field is required.'
								}, {
									validator: (rule, value, callback) => {
										if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
											callback('only white space detected.')
										}
										callback()
									}
								}]
							})
							(
								<Input.TextArea rows={4} placeholder='Enter purpose of certificate here..' />
							)}
						</Form.Item>
					</Row> */}
				</Form>
				{/* <div
					style={{
						position: 'absolute',
						right: 0,
						bottom: 10,
						width: '100%',
						borderTop: '1px solid #e9e9e9',
						padding: '10px 16px',
						background: '#fff',
						textAlign: 'center',
					}}
				>
					<button disabled={isSaving} type="button" className="btn btn-block btn-primary btn-rounded waves-effect waves-light" onClick={this.handleSubmit}>Save</button>
				</div> */}
			</Modal>
		)
	}
}

const GENERATE_CERTIFICATE = gql`
    mutation setCertificateBurial($input: JSON) {
		setCertificateBurial(input: $input)
    }
`

const composed = compose(
	Form.create({ name: 'form-generate-certificate' }),
	inject('AuthStore'),
	graphql(GENERATE_CERTIFICATE, {
		props({ mutate }) {
			return {
				saveCertificate(params) {
					return mutate({
						variables: { input: params },
					  	refetchQueries: ['allCertificateBurial']
					})
				}
			}
		}
	}),
	observer
)

export default composed(Index)
